module.exports = __webpack_public_path__ + "static/media/log.7b9c2e93.png";